// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"8a816f94","146":"4bad5132","153":"d9bcc318","230":"ed1758c6","352":"30e19215","408":"eba12f29","510":"322242b0","552":"754d1c57","578":"80b04eb5","623":"199f1924","930":"45c6d89b"}[chunkId] + ".chunk.js";
};